import { useMemo } from 'react';
import { RoiInterpretedType } from '~/domain/dicom/dicomstructureset';
import {
    findRoisByInterpretedType,
    StructureSetReadModel,
} from '~/domain/readmodels/StructureSetReadModel';

/**
 * The SUPPORT-typed structures in `structureSet`, which are what the
 * one-couch rule is stated over.
 *
 * ANY such structure counts, not only ones this tool wrote: a second couch
 * in one structure set would have a TPS compute dose through the
 * attenuation twice, and a couch imported from a TPS carries no provenance
 * of ours while being exactly the case most likely to double it. Scoped to
 * the interpreted type alone, with no generation-token check, because the
 * shared type is the only relationship a shell and its interior carry and
 * so the only handle by which "a couch already exists" can be judged.
 */
export function useSupportRois(
    structureSet: StructureSetReadModel | undefined
) {
    return useMemo(
        () =>
            structureSet
                ? findRoisByInterpretedType(
                      structureSet.roiArray,
                      RoiInterpretedType.SUPPORT
                  )
                : [],
        [structureSet]
    );
}
